(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.js-language-selector').forEach(selector => {
    const toggle = selector.querySelector('.language-selector__toggle');
    const list = selector.querySelector('.language-selector__list');

    if (!toggle || !list) return;

    // Toggle dropdown
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      list.hidden = isExpanded;
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!selector.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      }
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
        list.hidden = true;
        toggle.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
